import { DashboardService } from './../../dashboard.service';
import { Component, Input, OnInit } from '@angular/core';
import { Parameter } from 'src/app/apps/dashboard/dashboard';
import * as g from 'src/app/globals';

@Component({
  selector: 'app-param-date',
  templateUrl: './param-date.component.html',
  styleUrls: ['./param-date.component.less'],
})
export class ParamDateComponent implements OnInit {
  dateFormat = g.companyConfiguration.DateFormat;

  @Input() parameter: Parameter;
  @Input() dashboardParams: string[];
  @Input() dashboardParamNames: string[];
  @Input() dashboardId: number;

  constructor(private dashboardService: DashboardService) {}

  ngOnInit(): void {}

  valueChanged($event) {
    console.log($event);
    console.log(this.dashboardParams);

    this.dashboardService.triggerParameterValueChanged({
      dashboardId: this.dashboardId,
      dashboardParams: this.dashboardParams,
      dashboardParamNames: this.dashboardParamNames,
    });
  }
}
